module.exports = __webpack_public_path__ + "img/pluto70.6b739140.jpg";